import { useMutation } from '@tanstack/react-query'
import { transferServices } from '../transferServices'
import {
  EstimateConvertOrSellFeeDTO,
  GetEstimateConvertOrSellFeePayload,
} from '../transferTypes'
import { MUTATION_KEYS } from '@/constants/mutationKeys'

interface UseCalculateConversionFeeOptions {
  onSuccess?: (data: EstimateConvertOrSellFeeDTO) => void
  onError?: (error: any) => void
}

export const useCalculateConversionFee = (
  options?: UseCalculateConversionFeeOptions,
) => {
  const mutation = useMutation<
    EstimateConvertOrSellFeeDTO,
    Error,
    GetEstimateConvertOrSellFeePayload
  >({
    mutationFn: (data) => transferServices.calculateConversionFee(data),
    mutationKey: [MUTATION_KEYS.CALCULATE_CONVERSION_FEE],
    onSuccess: (data) => {
      if (options?.onSuccess) {
        options.onSuccess(data)
      }
    },
    onError: (err) => {
      if (options?.onError) {
        options.onError(err)
      }
    },
  })

  async function calculateConversionFee(
    data: GetEstimateConvertOrSellFeePayload,
  ) {
    return mutation.mutateAsync(data)
  }

  return {
    calculateConversionFee,
    isPending: mutation.isPending,
    error: mutation.error,
    data: mutation.data,
  }
}
